import { FC } from "react";
import { Ticket, TicketType } from "../../../components/TicketsPanel/Ticket"
import currencyIcon from '../../../icons/currency.png';
import { shortNumberForm } from "../../../utils/numbers";
import styles from './WheelPrize.module.scss';

export interface IWheelPrizeProps {
    type: TicketType | 'balance',
    value: number;
}

export const WheelPrize: FC<IWheelPrizeProps> = ({ type, value }) => {
    const getTicket = (type: TicketType) => <Ticket type={type} value={value} context='wheel-prize' />;

    const getBalance = () => {
        return (
            <div>
                <img src={ currencyIcon } alt="Currency Icon"  />
                <span className={ styles.balanceValue }>{ shortNumberForm(value, 0) }</span>
            </div>
        );
    }
    
    return type === 'balance' ? getBalance() : getTicket(type);
}